export enum BannerType {
  Critical = 'critical',
  Warning = 'warning',
  Info = 'info',
}

export const BannerIconConfig = {
  [BannerType.Critical]: 'error',
  [BannerType.Warning]: 'warning',
  [BannerType.Info]: 'info_outline',
};
